import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = {
  key: 0,
  class: "badge text-outline-info"
}
const _hoisted_16 = {
  key: 1,
  class: "badge text-outline-success"
}
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_18 = { class: "dropdown" }
const _hoisted_19 = { class: "dropdown-menu" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 2 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 3 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 4 }
const _hoisted_29 = { key: 5 }
const _hoisted_30 = { key: 6 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 7 }
const _hoisted_33 = { key: 8 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddTransfertModal = _resolveComponent("AddTransfertModal")!
  const _component_AddAnnulationMotifModal = _resolveComponent("AddAnnulationMotifModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.checkPermission('AddDemande'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                to: "/ajouter-demande"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1),
                  _createTextVNode(" Envoyer une demande ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher une demande"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _cache[21] || (_cache[21] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " REFERENCE "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " TYPE DE DEMANDE "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " ABONNEMENT "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " ABONNE "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " CONTENU "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " DATE "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " STATUT "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                }, "ACTIONS")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.demandes, (de, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(de.refDemande), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(de.typeDemande ? de.typeDemande.libelle : ''), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(de.abonnement ? de.abonnement.refAbo : ''), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(de.abonnement?.abonne ? de.abonnement.abonne.nomComplet : ''), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString((de.contenu.length > 25) ? de.contenu.substring(0, 25) + '...' : de.contenu), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.format_date(de.createdAt)), 1),
                  _createElementVNode("td", _hoisted_14, [
                    (de.status === 'En attente')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(de.status), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(de.status), 1))
                  ]),
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _cache[20] || (_cache[20] = _createElementVNode("span", {
                        class: "badge text-white bg-primary fs-15 dropdown-toggle",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createTextVNode(" Actions "),
                        _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_19, [
                        (_ctx.checkPermission('ViewDemande'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                              _createVNode(_component_router_link, {
                                to: { name: 'ViewDemandePage', params: { id: de.id } },
                                class: "dropdown-item d-flex align-items-center"
                              }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode("Détails ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["to"])
                            ]))
                          : _createCommentVNode("", true),
                        (de.typeDemande.id == 4 )
                          ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                              (de.status =='En attente' && _ctx.checkPermission('CheckEtatAttestation'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (_ctx.accept(de))
                                  }, [...(_cache[6] || (_cache[6] = [
                                    _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Accepter ", -1)
                                  ]))], 8, _hoisted_22))
                                : (de.status =='Acceptée' && _ctx.checkPermission('MakeAttestation'))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      class: "dropdown-item d-flex align-items-center",
                                      onClick: ($event: any) => (_ctx.produireAttestation(de))
                                    }, [...(_cache[7] || (_cache[7] = [
                                      _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Générer une attestation ", -1)
                                    ]))], 8, _hoisted_23))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (de.typeDemande.id == 1)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                              (de.status =='En attente')
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (_ctx.produireAttestation(de))
                                  }, [...(_cache[8] || (_cache[8] = [
                                    _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Accordée ", -1)
                                  ]))], 8, _hoisted_25))
                                : (de.status =='Accepté' && _ctx.agenceId == de.abonnement.bureau?.id)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 1,
                                      to: { name: 'AddAbonnementPage', params: { id:de.id } },
                                      class: "dropdown-item d-flex align-items-center"
                                    }, {
                                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                        _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Produire Abonnement ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (de.typeDemande.id ==7)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                              (de.status =='En attente' && _ctx.agenceId == de.abonnement.bureau?.id)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: { name: 'AccepterChangementClePage', params: { id:de.id } },
                                    class: "dropdown-item d-flex align-items-center"
                                  }, {
                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                      _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Acceptée ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["to"]))
                                : (de.status =='Acceptée' && _ctx.agenceId == de.abonnement.bureau?.id)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      class: "dropdown-item d-flex align-items-center",
                                      href: "javascript:void(0);",
                                      onClick: ($event: any) => (_ctx.traiterChangementDeCle(de))
                                    }, [...(_cache[11] || (_cache[11] = [
                                      _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Traitée ", -1)
                                    ]))], 8, _hoisted_27))
                                  : _createCommentVNode("", true)
                            ]))
                          : (de.typeDemande.id == 5)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                                (de.status == 'En attente' && _ctx.checkPermission('ManageResiliation') && _ctx.agenceId == de.abonnement.bureau?.id)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: { name: 'TraitementResiliationPage', params: { id:de.id } },
                                      class: "dropdown-item d-flex align-items-center"
                                    }, {
                                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                        _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Traiter ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (de.typeDemande.id == 8)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                                  (de.status == 'En attente' && _ctx.checkPermission('ManageReclamation') && _ctx.agenceId == de.abonnement.bureau?.id)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        to: { name: 'TraitementReclamationPage', params: { id:de.id } },
                                        class: "dropdown-item d-flex align-items-center"
                                      }, {
                                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                          _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Traiter ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["to"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (de.typeDemande.id == 2)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                                    ((de.status =='En attente' && _ctx.checkPermission('AcceptTransfert') && _ctx.agenceId == de.abonnement.bureau?.id) || (de.status =='En attente' && _ctx.role == 'Super Admin'))
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "dropdown-item d-flex align-items-center",
                                          href: "javascript:void(0);",
                                          onClick: ($event: any) => (_ctx.accept(de))
                                        }, [...(_cache[14] || (_cache[14] = [
                                          _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Acceptée ", -1)
                                        ]))], 8, _hoisted_31))
                                      : ((de.status =='Acceptée' && _ctx.checkPermission('ValidTransfert') && _ctx.agenceId == de.nouvelleAgence?.id) || (de.status =='Acceptée' && _ctx.role == 'Super Admin'))
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 1,
                                            to: { name: 'AddTransfertMpostBoxPage', params: { demande:de.id } },
                                            class: "dropdown-item d-flex align-items-center"
                                          }, {
                                            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                              _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                              _createTextVNode(" Valider ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["to"]))
                                        : _createCommentVNode("", true)
                                  ]))
                                : (de.status !=='Acceptée')
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                                      (de.status == 'En attente' && _ctx.checkPermission('CheckCession') && _ctx.agenceId == de.abonnement.bureau?.id)
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 0,
                                            to: { name: 'AcceptationCessionPage', params: { id:de.id } },
                                            class: "dropdown-item d-flex align-items-center"
                                          }, {
                                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                              _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                              _createTextVNode(" Vérification ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["to"]))
                                        : _createCommentVNode("", true),
                                      (de.status == 'Acceptée' && _ctx.checkPermission('ValidCession') && _ctx.agenceId == de.abonnement.bureau?.id)
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 1,
                                            to: { name: 'AddCessionPage', params: { id:de.id } },
                                            class: "dropdown-item d-flex align-items-center"
                                          }, {
                                            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                              _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                              _createTextVNode(" Valider ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["to"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                        (_ctx.checkPermission('RejetDemande'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#AddAnnulationMotifModal",
                                onClick: ($event: any) => (_ctx.annuleId(de.id))
                              }, [...(_cache[18] || (_cache[18] = [
                                _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Rejetée ", -1)
                              ]))], 8, _hoisted_34)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.openNewWindow_(de)),
                            type: "button",
                            class: "dropdown-item d-flex align-items-center"
                          }, [...(_cache[19] || (_cache[19] = [
                            _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Reçu de paiement ", -1)
                          ]))], 8, _hoisted_35)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddTransfertModal, {
      onGetAllDemandes: _ctx.getAllDemandes,
      id: _ctx.idTransfert,
      onOpenmodal: _ctx.showModalTransferEdite
    }, null, 8, ["onGetAllDemandes", "id", "onOpenmodal"]),
    _createVNode(_component_AddAnnulationMotifModal, {
      item: _ctx.selectedItem,
      onClose: _ctx.recharger,
      onOpenmodal: _ctx.show_Modal
    }, null, 8, ["item", "onClose", "onOpenmodal"])
  ], 64))
}